/* app/js/src/components/calendar/expandable/calendar-expandable-graphics-event/calendar-expandable-graphics-event.component.scss */
.event-wrapper {
  background-color: #e2e8f1;
  width: 100%;
  height: 35px;
  margin-top: 5px;
}
.item {
  display: flex;
  position: relative;
  background-color: #e2e8f1;
  width: 100%;
  height: 35px;
  margin-top: 5px;
  align-items: center;
  font-family: "Open Sans", sans-serif;
}
.visibility-icon {
  position: absolute;
  left: -23px;
  cursor: pointer;
}
.event-icon {
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.item-title-text {
  font-size: 12px;
  margin-left: 8px;
}
.event-container {
  font-size: 11px;
}
.item-title-container {
  display: flex;
  flex-direction: row;
  flex-basis: 119px;
}
.item-name {
  flex: 1 1 0%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-text-overrides {
  flex: 1 1 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
}
.item-text-overrides:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
.item-text-overrides .tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  left: 0;
  bottom: 100%;
  background-color: #333;
  color: #fff;
  padding: 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: normal;
  max-width: 300px;
  z-index: 1001;
  transition: opacity 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.item-text-overrides .tooltip:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 15px;
  border-width: 5px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}
.start-time-container {
  display: flex;
  flex-basis: 90px;
}
.end-time-container {
  display: flex;
  flex-basis: 90px;
}
.duration-time-container {
  display: flex;
  flex-basis: 90px;
}
.offset-time-container {
  display: flex;
  flex-basis: 90px;
}
.time-display {
  position: relative;
  left: 5px;
}
.in-front {
  display: flex;
  width: 100%;
  z-index: 1000;
}
.progress-bar {
  z-index: 500;
}
.right-items {
  display: flex;
  flex-direction: row;
  margin-left: auto;
  flex-basis: 100px;
}
.edit-item {
  font-size: 12px;
  text-decoration-line: underline;
  color: #40c4ff;
}
.trash-icon {
  cursor: pointer;
}
/*# sourceMappingURL=calendar-expandable-graphics-event.component.css.map */
